var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-selector-wrapper"},[_vm._t("default",null,{"openFileSelector":_vm.openFileSelector,"files":_vm.selectedFiles}),_vm._v(" "),_c('input',_vm._b({ref:"fileInput",staticClass:"input input--invisible",attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.fileChangeHandler}},'input',_vm.$attrs,false))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }